export enum ESelfDrivingLocomotiveState {
  SDLS_Idle,
  SDLS_FollowPath,
  SDLS_Docking,
  SDLS_DockingCompleted,
}
